'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _glamor = require('glamor');

var _Box = require('./Box');

var _Box2 = _interopRequireDefault(_Box);

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var majorScale = _theme2.default.majorScale;


var rotate360 = _glamor.css.keyframes('rotate360', {
  'from': {
    transform: 'rotate(0deg)'
  },
  'to': {
    transform: 'rotate(360deg)'
  }
});

var Spinner = function Spinner(props) {
  return _react2.default.createElement(_Box2.default, _extends({}, (0, _glamor.css)({
    '&, &:after': {
      borderRadius: '50%'
    },
    fontSize: '10px',
    position: 'relative',
    textIndent: '-9999em',
    borderTop: '2px solid ' + _theme2.default.colors.primary,
    borderRight: '2px solid ' + _theme2.default.colors.borderColor,
    borderBottom: '2px solid ' + _theme2.default.colors.borderColor,
    borderLeft: '2px solid ' + _theme2.default.colors.borderColor,
    transform: 'translateZ(0)',
    animation: rotate360 + ' 0.5s infinite linear'
  }), props));
};

Spinner.defaultProps = {
  width: majorScale(4),
  height: majorScale(4)
};

Spinner.displayName = 'Spinner';

exports.default = Spinner;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/Spinner.js
// module id = 588
// module chunks = 0